import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import Itemtax from "./ItemTax";
const ViewItemTax = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Item Tax Template - View</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{ flexGrow: '1' }}>
        <Itemtax />
      </div>
    </div>
  );
};
export default ViewItemTax
